export const DEFAULT_WITH_CAMERAS_LABEL = "With cameras";
export const DEFAULT_WITHOUT_CAMERAS_LABEL = "Without cameras";
export const DEFAULT_PRIMARY_BUTTON_LABEL = "Build my system";
export const DEFAULT_SECONDARY_BUTTON_LABEL = "Shop kits";

// Base System Drawer
export const DEFAULT_DRAWER_TITLE = "Base system";
export const DEFAULT_INTRO_FALLBACK =
  "Get full security setup by picking from ready-made kits or build your own.";
export const DEFAULT_INCLUDES_HEADING = "Each system includes:";
export const DEFAULT_BENEFITS_HEADING = "Benefits";
export const DEFAULT_BASE_CARD_TITLE = "Base";
export const DEFAULT_SENSOR_CARD_TITLE = "Door/Window Sensor";
export const DEFAULT_BASE_CARD_VIEW_DETAILS_LABEL = "View details";
export const DEFAULT_SENSOR_CARD_VIEW_DETAILS_LABEL = "View details";

export const DEFAULT_BASE_SYSTEM_DRAWER = {
  DEFAULT_DRAWER_TITLE,
  DEFAULT_INTRO_FALLBACK,
  DEFAULT_INCLUDES_HEADING,
  DEFAULT_BENEFITS_HEADING,
  DEFAULT_BASE_CARD_TITLE,
  DEFAULT_SENSOR_CARD_TITLE,
  DEFAULT_BASE_CARD_VIEW_DETAILS_LABEL,
  DEFAULT_SENSOR_CARD_VIEW_DETAILS_LABEL,
};
